import { FC } from "react";
import { Tabs } from "@rothoblaas/design-system";
import useI18n from "../../../../hooks/useTranslations";
import AdminGammaMValues from "./AdminGammaMValues";
import AdminKmodMatrix from "./AdminKmodMatrix";
import AdminLoadDurationClasses from "./AdminLoadDurationClasses";
import AdminServiceClasses from "./AdminServiceClasses";

const AdminNormativeTables: FC = () => {
  const i18n = useI18n();
  const t = i18n.translation.screwConnectorModule.normativeTables;

  return (
    <Tabs.SubTab>
      <Tabs renderMode="eager"
        urlParameter="normative_tables_tab"
        tabs={[
          { title: t.loadDurationClasses.plural },
          { title: t.serviceClasses.plural },
          { title: t.kmod.title },
          { title: t.gammaM.title },
        ]}
        contents={[<AdminLoadDurationClasses />, <AdminServiceClasses />, <AdminKmodMatrix />, <AdminGammaMValues />]}
      />
    </Tabs.SubTab>
  );
};

export default AdminNormativeTables;
